export default __webpack_public_path__ + "static/media/poster 1.ebb02a0d.jpg";